import bindStorage from 'nuxt-vuex-localstorage/plugins/bindStorage'

export default (ctx) => {
  const options = {"localStorage":["shoppingCartCheckoutAddresses","rememberedUser"]}
  bindStorage(ctx, options)
}
